import { useTranslation } from '@web_opxp/features';
import { CSSProperties } from 'react';
import { useSelector } from 'react-redux';
import * as Selectors from '../selectors';
import { TGlobalAchievements } from '../types';
import {
  getAchievementDescription,
  getAchievementIconSrc,
  getAchievementProgressFormat,
  getAchievementTitle,
} from '../utils';
import './GlobalAchievementCard.scss';

interface IGlobalAchievementCardProps {
  type: TGlobalAchievements;
  subType: number;
}

export default function GlobalAchievementCard({ type, subType }: Readonly<IGlobalAchievementCardProps>) {
  const { t } = useTranslation();
  const counter = useSelector((s: Selectors.IAppState) => Selectors.getCurrentCounterForGlobalAchievement(s, type));

  let suffix = '';

  if (counter === 0) {
    suffix = 'locked';
  } else if (counter < subType) {
    suffix = 'progress';
  }

  const imgSrc = getAchievementIconSrc(type, subType, suffix);
  const achievementTitle = getAchievementTitle(type, subType, t);
  const achievementDescription = getAchievementDescription(type, subType, t);
  if (!imgSrc || !achievementTitle || !achievementDescription) {
    return null;
  }
  const cardClassName = `global-achievement-card ${suffix}`;
  const progressLabel = getAchievementProgressFormat(type, counter, subType, t);
  return (
    <div className={cardClassName}>
      <img className="achievement-icon" src={imgSrc} alt={achievementTitle} />
      <h5>{achievementTitle}</h5>
      <h6>{achievementDescription}</h6>
      {suffix === 'progress' ? <AchievementCardProgress current={counter} max={subType} label={progressLabel} /> : null}
    </div>
  );
}

interface IAchievementCardProgressProps {
  current: number;
  max: number;
  label: string;
}

function AchievementCardProgress({ current, max, label }: Readonly<IAchievementCardProgressProps>) {
  const progress = Math.floor((current / max) * 100);
  const style = {
    '--progress': `${progress}%`,
  } as CSSProperties;
  return (
    <div className="achievement-progress" style={style}>
      <div className="achievement-progress-value"></div>
      <div className="achievement-progress-label">{label}</div>
    </div>
  );
}
